import { c as _c } from "react/compiler-runtime";
interface BottomNavHomeIconProps {
  className?: string;
}
const BottomNavHomeIcon = t0 => {
  const $ = _c(3);
  const {
    className
  } = t0;
  const t1 = `${className}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M5 23.75V12.5C5 12.1042 5.08875 11.7292 5.26625 11.375C5.44375 11.0208 5.68833 10.7292 6 10.5L13.5 4.875C13.9375 4.54167 14.4375 4.375 15 4.375C15.5625 4.375 16.0625 4.54167 16.5 4.875L24 10.5C24.3125 10.7292 24.5575 11.0208 24.735 11.375C24.9125 11.7292 25.0008 12.1042 25 12.5V23.75C25 24.4375 24.755 25.0263 24.265 25.5163C23.775 26.0063 23.1867 26.2508 22.5 26.25H18.75C18.3958 26.25 18.0992 26.13 17.86 25.89C17.6208 25.65 17.5008 25.3533 17.5 25V18.75C17.5 18.3958 17.38 18.0992 17.14 17.86C16.9 17.6208 16.6033 17.5008 16.25 17.5H13.75C13.3958 17.5 13.0992 17.62 12.86 17.86C12.6208 18.1 12.5008 18.3967 12.5 18.75V25C12.5 25.3542 12.38 25.6512 12.14 25.8912C11.9 26.1312 11.6033 26.2508 11.25 26.25H7.5C6.8125 26.25 6.22417 26.0054 5.735 25.5163C5.24583 25.0271 5.00083 24.4383 5 23.75Z" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <svg className={t1} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" fill="currentColor" width="30" height="30">{t2}</svg>;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
export default BottomNavHomeIcon;